import { useMutation, useQueryClient } from "react-query";
import { t } from "@/i18n-js/instance";
import { broadcastsApi } from "@/react/api/broadcastsApi";
import { getBroadcastQueryKey } from "@/react/components/SettingsApp/Emails/hooks/useGetBroadcast";
import { useToast } from "@circle-react-uikit/ToastV2";
import { templateLocaleNamespace } from "../../UpsertTemplateModal/UpdateTemplateContent";

export function useUpdateBroadcastTemplate() {
  const queryClient = useQueryClient();
  const toastr = useToast();

  return useMutation({
    mutationFn: broadcastsApi.updateTemplate,
    onSuccess: async (_, { id }) => {
      await queryClient.invalidateQueries(getBroadcastQueryKey(id));
      toastr.success(t([templateLocaleNamespace, "template_applied"]));
    },
    onError: (error: unknown) => {
      if (error instanceof Error && error.message) {
        return toastr.error(error.message);
      }

      toastr.error(t("unexpected_error"));
    },
  });
}
